import { render } from "./PageShell.vue?vue&type=template&id=827ce0b8"
import script from "./PageShell.vue?vue&type=script&lang=js"
export * from "./PageShell.vue?vue&type=script&lang=js"

import "./PageShell.vue?vue&type=style&index=0&id=827ce0b8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__